import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Globals } from '../objects/Globals';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../services/login.service';
import { Session } from '../objects/Session';
import { routerNgProbeToken } from '../../../node_modules/@angular/router/src/router_module';
import { TokenManager } from '../Globals';
import { SummaryService } from '../services/summary.service';

@Component({
  selector: 'app-layout-default',
  templateUrl: './layout-default.component.html',
  styleUrls: ['./layout-default.component.css']
})
export class LayoutDefaultComponent implements OnInit {
  private session:Session;
  private documentType:string;
  private documentSummaryName:string;
  private documentSummaryCardId:string;
  private selectedDetailType:string;
  private selectedDetailId:string;
  private selectedSubDetailType:string;
  private selectedSubDetailId:string;
  private searchKeyword: string = '';
  private componentId: string;
  smallPad: boolean = false;
  private fullDetail : boolean;
  private refreshView: boolean = false;
  private isShowBar: boolean = true;
  private smallSum: boolean = false;
  private onMobile: boolean;
  private summaryName: string;
  
  constructor(private route:ActivatedRoute, 
    public globals:Globals, 
    private router:Router, 
    private loginService:LoginService,
    private tokenManager:TokenManager,
    private summaryService:SummaryService) { }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth < 992) {
      this.smallPad = true;
      this.fullDetail = true;
      if (this.smallSum){
        this.onMobile = true;
      }
    }
    else{
      this.onMobile = false;
      this.fullDetail = false;
      if(this.isShowBar){
        this.smallPad = false;
      }
      
    }
  }

  onSelectedItem(selectedId:string) {
    this.selectedDetailId = selectedId;
    this.onMobile = window.innerWidth < 992;
    this.smallSum = true;
  }
  onSelectedType(selectedType:string) {
    this.selectedDetailType = selectedType;
    this.selectedSubDetailId = null;
    this.selectedSubDetailType = null;
  }

  onSelectedSubItemId(selectedId:string) {
    this.selectedSubDetailId = selectedId;
  }
  onSelectedSubItemType(selectedType:string) {
    this.selectedSubDetailType = selectedType;
  }

  onSearchKeywordChange(keyword:string){
    this.searchKeyword = keyword;
  }

  onViewChange(summaryId: string) {
      this.componentId = summaryId;
  }

  toggleSidebar(showView : boolean) {
    this.isShowBar = showView;
    if (showView){
      this.smallPad = false;
    }
    else{
      this.smallPad = true;
    }
  }

  setSummaryName($event){
    this.summaryName  = $event;
  }

  forceRefreshView(){
    this.refreshView = !this.refreshView;
  }

  toggleSummary(){
    this.smallPad = !this.smallPad;
  }

  switchSummary(){
    this.onMobile = false;
  }

  ngOnInit() {
    this.smallPad = (window.innerWidth) < 992;
    this.fullDetail = window.innerWidth < 992;
    
    
    var self = this;
    this.tokenManager.store("BRNCurrentRoute", this.router.url);
    if(this.globals.Session == null){
      self.router.navigate(['/', '/']) 
    }else{
      this.session = this.globals.Session.Session;
    }
    this.componentId = this.route.snapshot.paramMap.get('summaryId');
    if(this.route.snapshot.paramMap.get('detailComponentId')){
      this.selectedDetailId = this.route.snapshot.paramMap.get('detailComponentId');
    }

    // if(this.componentId && this.session){
    //   this.summaryService.getCurrentSearchKeyword(this.componentId).subscribe(result=>{
    //     if(result){
    //       this.searchKeyword = result;
    //     }else{
    //       this.searchKeyword = "";
    //     }
    //   })
    // }
  }
}
